import React from 'react';
import block from 'propmods';
import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Settings';
import { Field } from '../Form/Form';
import { DeviceLinking } from '../DeviceLinking/DeviceLinking';
import { DeviceLinkingDescription } from '../DeviceLinkingDescription/DeviceLinkingDescription';

import './DeviceLinkingSection.scss';

const b = block('DeviceLinkingSection');
const t = i18n(keyset);

export const DeviceLinkingSection: React.FC = () => {
    return (
        <div {...b()}>
            <h2 {...b('header')}>{t('devices-supported')}</h2>
            <div {...b('description')}>
                <DeviceLinkingDescription />
            </div>
            <Field label={t('devices-label')}>
                <DeviceLinking />
            </Field>
        </div>
    );
};
